import React from "react";
import { ComponentListPageContent, ComponentListPageStateProvider } from "./";
import { RootComponentEditDialogStateProvider } from "../dialog/root-component-edit-dialog";

export const ComponentListPage = () => {
  return (
    <ComponentListPageStateProvider>
      <RootComponentEditDialogStateProvider>
        <ComponentListPageContent />
      </RootComponentEditDialogStateProvider>
    </ComponentListPageStateProvider>
  );
};
